export default __webpack_public_path__ + "static/media/Inter-BlackItalic.a1ea21b0.woff2";